import React, {Component} from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import {Doughnut} from 'react-chartjs-2'
import {Chart, ArcElement} from 'chart.js'

Chart.register(ArcElement);

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);


export default class CircleChart extends Component {
  render() {
    const {
      registeredUsers,
      totalUsers
    } = this.props;

    const data = {
      datasets: [{
        data: [registeredUsers, (totalUsers - registeredUsers)],
      }],
      borderWidth: 2,
      spacing: 3,
      labels: [
        "Registrados",
        "No registrados"
      ]
    };

    const data1 = {
      datasets: [{
        data: [registeredUsers, 0],
      }],
      borderWidth: 2,
      spacing: 3,
      labels: [
        "Registrados",
        "No registrados"
      ]
    };

    return (
      <React.Fragment>
        <Doughnut
          data={registeredUsers<totalUsers ? data : data1}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            backgroundColor: ['#3AA52B', '#E2DEDE'],
            plugins: {
              legend: {
                display: false
              },
            },
            borderRadius : 95,
            cutout: 63,
            margin : 20,

          }}
          plugins={[
            {
              beforeDraw(chart) {
                const {width} = chart;
                const {height} = chart;
                const {data} = chart;
                const {ctx} = chart;
                ctx.restore();
                const fontSize = (height / 114).toFixed(2);
                ctx.font = `${fontSize}em roboto`;
                ctx.fillStyle = "#7E7E7E";
                ctx.textBaseline = "middle";
                const text = data.datasets[0].data[0];
                const textX = Math.round((width - ctx.measureText(text).width) / 2);
                const textY = height / 2;
                ctx.fillText(text, textX, textY);
                ctx.save();
              },
            },
          ]}
        />
      </React.Fragment>
    );
  }
}

export class CircleChartAssets extends Component {
  render() {
    const {assetList, folderSpaceInBytes, contractedSpaceInGb} = this.props;

    const colors = assetList.map((item) => {
      return item.background
    });
    const labels = assetList.map((item) => {
      return item.title
    });

    const data = {
      datasets: [{
        data: assetList.map((item) => {
          return item.qty
        }),
        borderWidth: 2,
        spacing: 2
      }],
      labels
    };

    const contractedSpaceInBytes = contractedSpaceInGb * 1024 * 1024 * 1024;
    const percent = (folderSpaceInBytes || 0) * 100 / contractedSpaceInBytes;

    return (
      <React.Fragment>
        <Doughnut
          data={data}
          redraw={true}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            backgroundColor: colors,
            plugins: {
              legend: {
                display: false
              },
            },
            borderRadius : 70,
            cutout: 63,
            margin : 20,
          }}
          plugins={[
            {
              beforeDraw(chart) {
                const {width} = chart;
                const {height} = chart;
                const {ctx} = chart;
                ctx.restore();
                const fontSize = (height / 114).toFixed(2);
                ctx.font = fontSize + "em roboto";
                ctx.textBaseline = "middle";
                ctx.fillStyle = "#7E7E7E";
                const text = Math.round(100 * percent) / 100.0 + "%",
                  textX = Math.round((width - ctx.measureText(text).width) / 2),
                  textY = height / 2;

                ctx.fillText(text, textX, textY);
                ctx.save();

              },
              draw: function (ease) {
                var ctx = this.chart.chart.ctx;

                var easingDecimal = ease || 1;
                Chart.helpers.each(this.getDataset().metaData, function (arc, index) {
                  arc.transition(easingDecimal).draw();

                  var vm = arc._view;
                  var radius = (vm.outerRadius + vm.innerRadius) / 2;
                  var thickness = (vm.outerRadius - vm.innerRadius) / 2;
                  var angle = Math.PI - vm.endAngle - Math.PI / 2;

                  ctx.save();
                  ctx.fillStyle = vm.backgroundColor;
                  ctx.translate(vm.x, vm.y);
                  ctx.beginPath();
                  ctx.arc(radius * Math.sin(angle), radius * Math.cos(angle), thickness, 0, 2 * Math.PI);
                  ctx.arc(radius * Math.sin(Math.PI), radius * Math.cos(Math.PI), thickness, 0, 2 * Math.PI);
                  ctx.closePath();
                  ctx.fill();
                  ctx.restore();
                });
              },
            },
          ]}
        />
      </React.Fragment>
    );
  }
}
